export default __webpack_public_path__ + "../images/legend-with-acars-unread.svg";